import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

const name = "sendPhotos";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

// const extraReducers = createExtraReducers();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const sendPhotosActions = { ...slice.actions, ...extraActions };
export const sendPhotosReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    PublicSentItemPhotoWebResponse: [],
    UpdateInmateConnectionResponse: [],
    PublicSentItemPhotoWeb: [],
    LoadPhotosDetailsResponse: [],
    CheckingMsgPhotoStatusResponse: [],
    user: getStoredValue("user"),
    CheckInmateConnectionStatus: []
  };
}
function createReducers() {
  return {
    clearEmailResponse,
    clearMsgPhotoStatusResponse,
    clearInmateConnectionStatusResponse,
    clearPhotosDetailsResponse
  };
  function clearEmailResponse(state) {
    state.UpdateInmateConnectionResponse = [];
    state.UpdateInmateConnection = [];
    state.user = null;
  }
  function clearMsgPhotoStatusResponse(state) {
    state.CheckingMsgPhotoStatusResponse = [];
  }
  function clearInmateConnectionStatusResponse(state) {
    state.CheckInmateConnectionStatus = [];
  }
  function clearPhotosDetailsResponse(state) {
    state.LoadPhotosDetailsResponse = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/Inbox`;
  const SendPhotosUrl = `${process.env.REACT_APP_API_URL}/PublicUser/SendPhotos`;
  const MyContactsBaseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/MyContacts`;

  return {
    PublicSentItemPhotoWeb: PublicSentItemPhotoWeb(),
    UpdateInmateConnection: UpdateInmateConnection(),
    LoadPhotosDetails: LoadPhotosDetails(),
    CheckingMsgPhotoStatus: CheckingMsgPhotoStatus(),
    LoadPublicInmateConnectionDet: LoadPublicInmateConnectionDet(),
  };
  function PublicSentItemPhotoWeb() {
    return createAsyncThunk(
      `${name}/PublicSentItemPhotoWeb`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicSentItemPhotoWeb`,
          addFormData
        )
    );
  }

  function UpdateInmateConnection() {
    return createAsyncThunk(
      `${name}/UpdateInmateConnection`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${MyContactsBaseUrl}/UpdateInmateConnection`,
          addFormData
        )
    );
  }

  function LoadPhotosDetails() {
    return createAsyncThunk(
      `${name}/loadPhotoDetails`,
      async ({ PhotoCommID }) =>
        await fetchWrapper.post(`${SendPhotosUrl}/LoadPhotoDetailsFromFilePath?PhotoCommID=${PhotoCommID}`)
    );
  }

  function CheckingMsgPhotoStatus() {
    return createAsyncThunk(
      `${name}/CheckingMsgPhotoStatus`,
      async ({ addFormData }) =>
        await fetchWrapper.post(`${SendPhotosUrl}/CheckingMsgPhotoPurchaseCreditStatus?UserID=${addFormData.UserID}&InmateID=${addFormData.InmateID}`)
    );
  }

  function LoadPublicInmateConnectionDet() {
    return createAsyncThunk(
      `${name}/LoadPublicInmateConnectionDet`,
      async ({ userID,
        inmatesID }) =>
        await fetchWrapper.post(
          `${MyContactsBaseUrl}/LoadPublicInmateConnectionDet?userID=${userID}&inmatesID=${inmatesID}`,
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    // Handle PublicSentItemPhotoWeb
    .addCase(extraActions.PublicSentItemPhotoWeb.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.PublicSentItemPhotoWeb.fulfilled, (state, action) => {
      state.PublicSentItemPhotoWebResponse = [];
      state.PublicSentItemPhotoWeb = action.payload;
    })
    .addCase(extraActions.PublicSentItemPhotoWeb.rejected, (state, action) => {
      state.error = action.error.message;
    })


    // UpdateInmateConnection
    .addCase(extraActions.UpdateInmateConnection.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.UpdateInmateConnection.fulfilled, (state, action) => {
      state.UpdateInmateConnectionResponse = [];
      state.UpdateInmateConnection = action.payload;
    })
    .addCase(extraActions.UpdateInmateConnection.rejected, (state, action) => {
      state.error = action.error.message;
    })


    // Load Photos Details
    .addCase(extraActions.LoadPhotosDetails.pending, (state) => {
      state.error = null;
      state.LoadPhotosDetailsResponse = [];
    })
    .addCase(extraActions.LoadPhotosDetails.fulfilled, (state, action) => {
      state.LoadPhotosDetailsResponse = action.payload;
    })
    .addCase(extraActions.LoadPhotosDetails.rejected, (state, action) => {
      state.error = action.error.message;
    })


    // Checking Message and Photo Status
    .addCase(extraActions.CheckingMsgPhotoStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.CheckingMsgPhotoStatus.fulfilled, (state, action) => {
      state.CheckingMsgPhotoStatusResponse = [];
      state.CheckingMsgPhotoStatusResponse = action.payload;
    })
    .addCase(extraActions.CheckingMsgPhotoStatus.rejected, (state, action) => {
      state.error = action.error.message;
    })

    .addCase(extraActions.LoadPublicInmateConnectionDet.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicInmateConnectionDet.fulfilled,
      (state, action) => {
        state.CheckInmateConnectionStatus = action.payload;
      }
    )
    .addCase(
      extraActions.LoadPublicInmateConnectionDet.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    );

}


